import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(3),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        marginTop: '-1%',
        marginBottom: '3.2%',
        display: 'flex',
        flexDirection: 'column',
    },
}));

export default function ListValidaciones({ rows, isLoadUser, nameBascula, idBasula, primaryColor, busqueda, handleAñadirOximetria }) {
    const classes = useStyles();
    function formatDate(fecha) {
        if (!fecha) {
            return '--';
        }

    
        fecha.setUTCHours(0, 0, 0, 0);

        const day = String(fecha.getUTCDate()).padStart(2, '0');
        const month = String(fecha.getUTCMonth() + 1).padStart(2, '0');
        const year = fecha.getUTCFullYear();

        return `${day}/${month}/${year}`;
    }

    function calculateAge(dateOfBirth) {
    
        if (!dateOfBirth) {
            return '--';
        }

        let dob;
        if (dateOfBirth.includes('-')) {
            const [year, month, day] = dateOfBirth.split('-');
            dob = new Date(year, month - 1, day);
        } else if (dateOfBirth.includes('/')) {
            const [year, month, day] = dateOfBirth.split('/');
            dob = new Date(year, month - 1, day);
        } else {
            console.error('Formato de fecha no reconocido');
            return null;
        }

      
        if (isNaN(dob.getTime())) {
            console.error('Fecha de nacimiento no válida');
            return null;
        }

        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age;
    }
    return (
        <>
            {isLoadUser ? (
                <></>
            ) : (
                <Paper className={classes.card}>
                    <Grid container spacing={1}>
                        <Typography style={{ width: '18%', fontWeight: 'bold', fontSize: '17px' }}>
                            {rows.nombre || '--'}
                        </Typography>
                        <Typography style={{ width: '15%', fontWeight: 'bold', fontSize: '17px', paddingRight: '2%' }}>
                            {rows.celular || '--'}
                        </Typography>
                        <Typography style={{ width: '13%', fontWeight: 'bold', fontSize: '17px' }}>
                            {rows.numerodocumento || '--'}
                        </Typography>
                        <Typography style={{ width: '22%', fontWeight: 'bold', fontSize: '17px' }}>
                            {rows.email || '--'}
                        </Typography>
                        <Typography style={{ width: '18%', fontWeight: 'bold', fontSize: '17px' }}>
                            {rows.edad ? formatDate(new Date(rows.edad)) : '--'}
                        </Typography>
                        <Typography style={{ width: '6%', fontWeight: 'bold', fontSize: '17px' }}>
                            {rows.edad ? calculateAge('1965-05-12') : '--'}
                        </Typography>

                    </Grid>
                </Paper>
            )}
        </>
    );
}